<div class="dialog-header flex align-items-center justify-content-between w-full">
  <h2>Adaugă utilizator</h2>
  <p-button
    data-testid="dialog-secondary"
    mat-dialog-close
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  @if (!isCreating()) {
    <form [formGroup]="userForm" class="grid">
      @if (!userForm.get("customIdentifier")?.value) {
        <p-messages
          styleClass="text-xs"
          class="col-12"
          [value]="autoGeneratedIdentifierMessage()"
          [enableService]="false"
          [closable]="false" />
      }

      @if (!!userForm.get("noEmailAddress")?.value) {
        <p-messages
          styleClass="text-xs -my-3"
          class="col-12"
          [value]="noEmailAddressWarningMessage()"
          [enableService]="false"
          [closable]="false"
        />
      }
      <div class="col-12 sm:col-6">
        <span class="block font-bold mb-1">Nume</span>
        @let name = userForm.get("name");
        <input
          autocomplete="off"
          class="w-full"
          type="text"
          pInputText
          placeholder="Nume"
          pAutoFocus
          [autofocus]="true"
          formControlName="name"
        >
        @let nameErrors = userForm.get("name")?.errors;
        @if (name?.dirty) {
          @if (nameErrors) {
            @if (nameErrors?.["required"]) {
              <small class="text-red-500">Câmpul este obligatoriu!</small>
            }
          }
        }
      </div>

      <div class="col-12 sm:col-6">
        <span class="font-bold block mb-1">Identificator</span>
        @let identifier = userForm.get("identifier");
        <input
          formControlName="identifier"
          class="w-full"
          id="awb"
          [placeholder]="identifier?.disabled ? 'Se va genera automat' : 'Introduceți identificatorul'"
          pInputText
        >
        @let identifierErrors = userForm.get("identifier")?.errors;
        @if (identifier?.dirty) {
          @if (identifierErrors) {
            @if (identifierErrors?.["required"]) {
              <small class="text-red-500">Câmpul este obligatoriu!</small>
            }
          }
        }
        <div class="flex align-items-center gap-2">
          <p-checkbox
            class="mt-1"
            [binary]="true"
            formControlName="customIdentifier"
            inputId="customIdentifier"
            (onChange)="toggleCustomIdentifier(); identifier?.reset();"
          ></p-checkbox>
          <label class="-mb-1 text-xs" for="customIdentifier">Identificator personalizat</label>
        </div>
      </div>

      <div class="col-12 sm:col-6">
        <span class="font-bold block mb-1">Email</span>
        @let email = userForm.get("email");
        <input
          class="w-full"
          type="text"
          pInputText
          [placeholder]="email?.disabled ? '' : 'test@companie.ro'"
          formControlName="email"
        >
        @let emailErrors = userForm.get("email")?.errors;
        @if (email?.dirty) {
          @if (emailErrors) {
            @if (emailErrors?.["required"]) {
              <small class="text-red-500">Câmpul este obligatoriu!</small>
            }
          }
        }
        <div class="flex align-items-center gap-2">
          <p-checkbox
            class="mt-1"
            [binary]="true"
            formControlName="noEmailAddress"
            inputId="noEmailAddress"
            (onChange)="noEmailAddressToggled(); email?.reset();"
          ></p-checkbox>
          <label class="-mb-1 text-xs" for="noEmailAddress">Utilizatorul nu are adresă de email</label>
        </div>
      </div>

      <div
        class="col-12 sm:col-6"
      >
        <span class="font-bold block mb-1">Telefon</span>
        @let phone = userForm.get("phone");
        <input
          class="w-full"
          type="tel"
          pKeyFilter="int"
          pInputText
          [placeholder]="phone?.disabled ? '' : '07xxxxxxxx'"
          formControlName="phone"
        />
        @let phoneErrors = userForm.get("phone")?.errors;
        @if (phone?.dirty) {
          @if (phoneErrors) {
            @if (phoneErrors?.["required"]) {
              <small class="text-red-500">Câmpul este obligatoriu!</small>
            }
          }
        }
        <div class="flex align-items-center gap-2">
          <p-checkbox
            class="mt-1"
            [binary]="true"
            formControlName="noPhoneNumber"
            inputId="noPhoneNumber"
            (onChange)="noPhoneNumberToggled(); phone?.reset();"
          ></p-checkbox>
          <label class="-mb-1 text-xs" for="noPhoneNumber">Utilizatorul nu are număr de telefon</label>
        </div>
      </div>

      <div class="col-12">
        <span class="block font-bold mb-1">Rol</span>
        <p-dropdown
          optionLabel="roleName"
          optionValue="roleName"
          styleClass="w-full"
          placeholder="Selectați un rol"
          formControlName="role"
          [options]="roles()"
          [loading]="!roles()"
        ></p-dropdown>
      </div>

      <div class="col-12">
        <span class="block font-bold mb-1">Extensii rol</span>
        <p-multiSelect
          optionValue="value"
          optionLabel="label"
          optionDisabled="disabled"
          styleClass="w-full"
          placeholder="Extindeți drepturile utilizatorului"
          formControlName="roleExtensions"
          [options]="roleExtensions()"
          [loading]="!roles()"
          [showToggleAll]="false"
          (onChange)="roleExtensionsChanged($event)"
        >
          <ng-template pTemplate="item" let-extension>
            {{ $any(roleExtensionsMapping())[extension.value] }}
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="col-12">
        <span class="font-bold block mb-1">Zonă</span>
        <p-dropdown
          formControlName="zoneId"
          optionLabel="name"
          optionValue="id"
          placeholder="Selectează o zonă"
          styleClass="w-full"
          appendTo="body"
          filterBy="name"
          [filter]="true"
          [options]="zones()"
          [loading]="!zonesFetched()"
        />
        @let zone = userForm.get("zoneId");
        @let zoneErrors = zone?.errors;
        @if (zone?.dirty) {
          @if (zoneErrors?.["minlength"]) {
            <small class="text-red-500">Vă rugăm să selectați zona de acces</small>
          }
        }
      </div>

      <p-messages
        styleClass="text-xs m-0"
        class="col-12"
        severity="info"
      >
          <ng-template pTemplate>
            <div class="flex align-items-center gap-2">
              <div class="flex-column">
                <div>În cazul în care doriți ca acest utilizator să aibă și acces fizic la lockere, bifați căsuța de mai jos.</div>
                <div class="flex align-items-center gap-2">
                  <p-checkbox class="mt-1" [binary]="true" formControlName="shouldCreateAgent"
                    inputId="shouldCreateAgent"></p-checkbox>
                  <label class="-mb-1 text-xs" for="shouldCreateAgent">Utilizatorul este si agent</label>
                </div>
              </div>
            </div>
          </ng-template>
      </p-messages>

      <div class="col-12">
        <span class="font-bold block mb-1">Notițe</span>
        <textarea
          class="w-full"
          rows="5"
          cols="30"
          pInputTextarea
          formControlName="notes"
        ></textarea>
      </div>
    </form>
  } @else {
    <div class="grid">
      <div class="col-12 py-4">
        <div class="flex align-items-center my-2">
          @if (userCreateStatus() === "unknown") {
            <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
            <p class="m-0 ml-2 text-lg">Se creează utilizatorul...</p>
          }
          @else if (userCreateStatus() === "success") {
            <span class="pi pi-check-circle text-green-500 text-lg"></span>
            <p class="m-0 ml-2 text-lg">Utilizatorul a fost creat cu succes!</p>
          } @else if (userCreateStatus() === "error") {
              <span class="pi pi-times-circle text-red-500 text-lg"></span>
              <p class="m-0 ml-2 text-lg">Eroare la crearea utilizatorului</p>
            @if (userSaveRetryAllowed()) {
              <p-button
                size="small"
                styleClass="px-2 py-1 text-xs ml-3"
                label="Reîncearcă"
                [link]="true"
                (click)="retryUserSave()"
              ></p-button>
            }
          }
        </div>

        @if (userSaveRetryAllowed() && !!this.userForm.get("shouldCreateAgent")?.value) {
          @if (userCreateStatus() === "success") {
            <div class="flex align-items-center my-2">
              @if (agentCreateStatus() === "unknown") {
                <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
                <p class="m-0 ml-2 text-lg">Se creează agentul...</p>
              }
              @else if (agentCreateStatus() === "success") {
                <span class="pi pi-check-circle text-green-500 text-lg"></span>
                <p class="m-0 ml-2 text-lg">Agentul a fost creat cu succes!</p>
              } @else if (agentCreateStatus() === "error") {
                  <span class="pi pi-times-circle text-red-500 text-lg"></span>
                  <p class="m-0 ml-2 text-lg">Eroare la crearea agentului</p>
                @if (agentSaveRetryAllowed()) {
                  <p-button
                    size="small"
                    styleClass="px-2 py-1 text-xs ml-3"
                    label="Reîncearcă"
                    [link]="true"
                    (click)="retryUserSave()"
                  ></p-button>
                }
              }
            </div>
          }
        }
      </div>
    </div>
  }
</mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (!isCreating()) {
      <button
        pButton
        size="small"
        data-testid="dialog-primary"
        label="Adaugă"
        iconPos="left"
        icon="pi pi-plus"
        (click)="saveUser()"
      ></button>
    }
  </mat-dialog-actions>
